var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29297 3.75928L3.14971 17.4671C3.1904 18.2592 3.76656 18.8379 4.52049 18.8379H12.4025C13.1594 18.8379 13.7249 18.2592 13.7733 17.4671L14.63 3.75928",
    stroke: "#D71513",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.921875 3.75928H16.0005H0.921875Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.921875 3.75928H16.0005",
    stroke: "#D71513",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7177 3.75866V2.04518C5.7173 1.91006 5.74362 1.77619 5.79515 1.65128C5.84667 1.52637 5.92239 1.41288 6.01793 1.31733C6.11348 1.22179 6.22697 1.14607 6.35188 1.09455C6.4768 1.04302 6.61066 1.0167 6.74578 1.01709H10.1727C10.3079 1.0167 10.4417 1.04302 10.5666 1.09455C10.6916 1.14607 10.8051 1.22179 10.9006 1.31733C10.9961 1.41288 11.0719 1.52637 11.1234 1.65128C11.1749 1.77619 11.2012 1.91006 11.2008 2.04518V3.75866M5.375 6.50023L5.7177 16.0957M11.5435 6.50023L11.2008 16.0957",
    stroke: "#D71513",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.c815ec82b7c6206f5ab2c44dd11d0925.svg";
export { ForwardRef as ReactComponent };